import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";

const PublicRoute = () => {
  const loginSts = localStorage.getItem("user") ? true : false;
  const isAuthenticated = useSelector((state) => loginSts || false);
  return isAuthenticated ? <Navigate to="/dashboards" /> : <Outlet />;
};

export default PublicRoute;
